import { atom } from 'jotai';

import type { Company } from '@/types/directory/Company';

export const companyAtom = atom<Company>();
